/* ==========================================================================
   Filter By Climate — client-side temperature-range product filter
   Reads the JSON payload rendered by sections/filter-by-climate.liquid,
   parses each product's custom.temperature_range value for two numbers
   (a min and max °C), and shows matching rows when the form is submitted.
   The customer can enter a single temperature (min only) or a min/max
   range — a match is any overlap between the customer's range and the
   product's operating range. Add-to-cart buttons use the theme's existing
   [data-add-to-cart] handler already wired up in assets/cart-drawer.js —
   nothing extra to hook up here.
   ========================================================================== */
(function () {
  'use strict';

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  // Pulls the first two numbers (handles decimals and negatives) out of a
  // free-text range like "10-30", "10 to 30°C", "10°C – 30°C". A single
  // number ("18°C") is treated as an exact point (min === max).
  function parseRange(text) {
    var matches = String(text).match(/-?\d+(\.\d+)?/g);
    if (!matches || !matches.length) return null;
    var min = parseFloat(matches[0]);
    var max = matches.length > 1 ? parseFloat(matches[1]) : min;
    if (min > max) {
      var swap = min;
      min = max;
      max = swap;
    }
    return { min: min, max: max };
  }

  function buildRow(product) {
    var tr = document.createElement('tr');

    var img = product.image
      ? '<img src="' + escapeHtml(product.image) + '" alt="" width="52" height="52" loading="lazy">'
      : '';

    var cartCell;
    if (!product.available) {
      cartCell = '<button type="button" class="button button--sm" disabled>Sold out</button>';
    } else if (product.single_variant) {
      cartCell =
        '<button type="button" class="button button--sm" data-add-to-cart data-variant-id="' +
        escapeHtml(product.variant_id) + '">Add</button>';
    } else {
      cartCell =
        '<a href="' + escapeHtml(product.url) + '" class="button button--sm button--secondary">Choose options</a>';
    }

    tr.innerHTML =
      '<td><a href="' + escapeHtml(product.url) + '" class="filter-climate__product">' + img +
      '<span>' + escapeHtml(product.title) + '</span></a></td>' +
      '<td>' + escapeHtml(product.range) + '</td>' +
      '<td>' + cartCell + '</td>' +
      '<td><a href="' + escapeHtml(product.url) + '" class="link-arrow">Details</a></td>';

    return tr;
  }

  function init(section) {
    var form = section.querySelector('[data-climate-filter-form]');
    var minInput = section.querySelector('[data-climate-temp-min]');
    var maxInput = section.querySelector('[data-climate-temp-max]');
    var status = section.querySelector('[data-climate-status]');
    var table = section.querySelector('[data-climate-table]');
    var tbody = section.querySelector('[data-climate-table-body]');
    var dataEl = section.querySelector('[data-climate-products]');
    if (!form || !dataEl || !minInput) return;

    var products = [];
    try {
      products = JSON.parse(dataEl.textContent || '[]');
    } catch (err) {
      products = [];
    }

    var noResultsText = section.getAttribute('data-no-results-text') || 'No products match that temperature.';
    var invalidText = section.getAttribute('data-invalid-text') || 'Please enter a valid temperature.';

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var searchMin = parseFloat(minInput.value);
      var maxRaw = maxInput ? maxInput.value : '';
      var searchMax = maxRaw === '' ? searchMin : parseFloat(maxRaw);

      if (isNaN(searchMin) || isNaN(searchMax)) {
        table.hidden = true;
        status.hidden = false;
        status.textContent = invalidText;
        return;
      }

      if (searchMin > searchMax) {
        var swap = searchMin;
        searchMin = searchMax;
        searchMax = swap;
      }

      // Overlap test: does the customer's [searchMin, searchMax] range
      // intersect the product's [range.min, range.max] at all?
      var matches = products.filter(function (product) {
        var range = parseRange(product.range);
        return range && searchMax >= range.min && searchMin <= range.max;
      });

      tbody.innerHTML = '';
      matches.forEach(function (product) {
        tbody.appendChild(buildRow(product));
      });

      if (!matches.length) {
        table.hidden = true;
        status.hidden = false;
        status.textContent = noResultsText;
      } else {
        status.hidden = true;
        table.hidden = false;
      }
    });
  }

  document.querySelectorAll('[data-climate-filter-section]').forEach(init);
})();